import { NotificationSettings, SslCertificateIssue, UserType } from ".";

export class Tenant {
    public name: string;
    public id: string;
    public auditEnabled: boolean;
    public auditViewPageEventsEnabled: boolean;
    public domainAliases: string[];
    public customerVerification: boolean;
    public creationDate: number;
    public enableSmartWarranty: boolean;
    public scoreRecaptchaThreshold: number;
    public maxParameterCountPerMessage: number;
    public maxEndUserApiKeyRequestCount: number;
    public maxEndUserApiKeyRequestCountPerMonth: number;
    public enableFirmware: boolean;
    public enableAlertStatistics: boolean;
    public enableWorkSessionStatistics: boolean;
    public enableDocumentation: boolean;
    public denyAllUserAuthorization: boolean;
    public enableRecipes: boolean;
    public enableFeedbackPageLink: boolean;
    public maxInactivityMonths: number;
    public alertCriticalSeverityType: string;
    public thingCloudExpireDateEnabled: boolean;
    public forceMaxOneTagPerThing: boolean;
    public nullValueEnabled: boolean;
    public defaultNullValue: string;
    public servicePurchaseBackOfficeApprovalEnabled: boolean;
    public thingDefaultPropertySettings: ThingDefaultPropertySettings[];
    public thingDefinitionDefaultPropertySettings: DefaultPropertySettings[];
    public customerDefaultPropertySettings: CustomerDefaultPropertySettings[];
    public locationDefaultPropertySettings: LocationDefaultPropertySettings[];
    public partnerDefaultPropertySettings: PartnerDefaultPropertySettings[];
    public userDefaultPropertySettings: DefaultPropertySettings[];
    public domainAliasesSslCertificatePresent: boolean;
    public domainAliasesSslCertificateKeyPresent: boolean;
    public domainAliasesSslCertificateExpirationTimestamp: number;
    public domainAliasesSslCertificateIssues: SslCertificateIssue[];
    public thingDefinitionAlgorithmsMinComputationPeriod: ThingDefinitionAlgorithmsMinComputationPeriod;
    public selfRegistrationEnabled: boolean;
    public selfRegistrationCustomerTypes: CustomerType[];
    public selfRegistrationDefaultLocationCreationEnabled: boolean;
    public configurationPlan: ConfigurationPlan;
    public defaultLoginPage: string;
    public languageSelectorEnabled: boolean;
    public listRangeSelectionMode: ListRangeSelectionModeType;
    public domainAliasesSslCertificateMode: SslCertificateMode;
    public userPasswordPublicInformationCheckEnabled: boolean;
    public userPasswordDictionaryCheckEnabled: boolean;
    public partnerSelfRegistrationEnabled: boolean;
    public defaultOrganizationUserType: UserType;
    public defaultPartnerUserType: UserType;
    public defaultCustomerUserType: UserType;
    public thingInventoryManagement: ThingInventoryManagementType;
    public features: string[];
    public languages: string[];
    public digitalServicesEnabled: boolean;
    public rawDataRetentionMonths: number;
    public uncodedActionSparePartsEnabled: boolean;
    public timezoneSelectorEnabled: boolean;
    public automaticTimezonePreferenceEnabled: boolean;
    public serviceLevelsEnabled: boolean;
    public defaultPeriods: string[];
    public deferredPaymentEnabled: boolean;
    public workOrderExtraPropertiesEnabled: boolean;
    public newNotificationSettingsEnabled: boolean;
    public defaultNotificationSettings: NotificationSettings;
    public workOrderReportCoverTemplate: string;
    public workOrderReportDetailsTemplate: string;
    public workOrderReportFileName: string;
    public workOrderReportNotesIncluded: boolean;
    public workOrderReportAttachmentsIncluded: boolean;
    public workOrderReportSparePartsIncluded: boolean;
    public newStyleManagerEnabled: boolean;
    public captchaType: CaptchaType;
}

export class DefaultPropertySettings {
    public name: string;
    public mandatory: boolean;
    public unique: boolean;
    public userTypeFiltered: boolean;
    public userTypeIds: string[];
}

export class ThingDefaultPropertySettings extends DefaultPropertySettings {
    public boundToGpsCoordinates?: boolean;
}

export class LocationDefaultPropertySettings extends DefaultPropertySettings {
    public derivedValue?: boolean;
    public valueExpression?: string;
    public boundToGpsCoordinates?: boolean;
}

export class CustomerDefaultPropertySettings extends DefaultPropertySettings {
    public billingInformation?: boolean;
    public mandatoryForBilling?: boolean;
}

export class PartnerDefaultPropertySettings extends DefaultPropertySettings {
    public billingInformation?: boolean;
    public mandatoryForBilling?: boolean;
}

export enum ThingDefinitionAlgorithmsMinComputationPeriod {
    MINUTES_5 = "MINUTES_5",
    HOURS_1 = "HOURS_1",
    DAYS_1 = "DAYS_1"
}

export enum CustomerType {
    BUSINESS = "BUSINESS",
    PERSONAL = "PERSONAL",
    PARTNER = "PARTNER",
    DATA_RECIPIENT = "DATA_RECIPIENT"
}

export class ConfigurationPlan {
    public maxBusinessMetricCount: number;
    public maxWorkSessionDefinitionCount: number;
    public minBusinessMetricSamplingPeriod: string;
}

export enum ListRangeSelectionModeType {
    ITEMS = "ITEMS",
    PAGES = "PAGES"
}

export enum SslCertificateMode {
    IMPORT = "IMPORT",
    FREE = "FREE",
    PROXY = "PROXY"
}

export enum ThingInventoryManagementType {
    BY_THING_DEFINITION = "BY_THING_DEFINITION",
    BY_THING_DEFINITION_AND_MODEL = "BY_THING_DEFINITION_AND_MODEL",
    BY_MODEL = "BY_MODEL"
}

export enum CaptchaType {
    NONE = "NONE",
    GOOGLE = "GOOGLE",
    ALIBABA = "ALIBABA"
}